import React, { Component } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { privacyPolicyData } from '../../../utils/mockData'
import { withRouter } from 'react-router-dom';
import UUID from 'uuid';
const privacyPolicy = privacyPolicyData();

const Header = (props) => {
    return (
        <Row>
            <Col>
                <Card>
                    <CardBody>
                        <Row style={{
                            flex: 1,
                            justifyContent: 'space-around',
                            marginBottom: '5px'
                        }}>
                            <Col md={1}>
                                <img
                                    alt='company-logo'
                                    src={`${process.env.PUBLIC_URL}/img/privacy.png`}
                                    height="40px"
                                    width="40px" />
                            </Col>
                        </Row>
                        <h1 style={{ "textAlign": "center", color: '#000080' }}>Privacy Policy</h1>
                        <p style={{ "textAlign": "center" }}>Last Updated: {`${props.date}`}</p>
                        <hr />

                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

const Prelude = (props) => {
    return (
        <div style={{ paddingRight: '60px', paddingLeft: '60px' }}>
            <Col md={12}>
                <Card>
                    <CardBody>
                        <p>
                            <strong>{`${props.websitename}`}</strong>
                            ("us", "we", or "our") operates the <strong>{`${props.url}`}</strong>(the "Service").</p>
                        <p>
                            This page informs you of our policies regarding the collection,
                            use, and disclosure of personal data when you use our Service
                            and the choices you have associated with that data.
                        </p>
                        <p>
                            We use your data to provide and improve the Service. By using
                            the Service, you agree to the collection and use of information
                            in accordance with this policy. Unless otherwise defined in this
                            Privacy Policy, terms used in this Privacy Policy have the same
                            meanings as in our Terms and Conditions, accessible from {`${props.url}`}
                        </p>
                    </CardBody>
                </Card>
            </Col>
        </div>
    )
}


const Body = (props) => {
    return (
        <div style={{ paddingRight: '60px', paddingLeft: '60px' }}>
            <Col md={12} lg={12}>
                <Card>
                    <CardBody>
                        <h3 style={{ "textAlign": "center" }} className="Number1">Information Collection And Use</h3>
                        <p>
                            We collect several different types of information for various
                            purposes to provide and improve our Service to you.
                        </p>
                        <br />
                        <h4 >Types of Data Collected</h4>
                        <br />
                        <h5 style={{ "fontWeight": 'bold' }}>Personal Data</h5>
                        <p>
                            While using our Service, we may ask you to provide us with
                            certain personally identifiable information that can be used
                            to contact or identify you ("Personal Data"). Personally
                            identifiable information may include, but is not limited to:
                        </p>
                        <ul style={{ color: '#37414F' }}>
                            {
                                privacyPolicy.personalinfo.map(info => {
                                    return <li key={UUID()} style={{ color: '#37414F' }}>{info}</li>
                                })
                            }
                        </ul>
                        <br />
                        <h5 style={{ "fontWeight": 'bold' }}>Usage Data</h5>
                        <p>
                            We may also collect information how the Service is accessed and
                            used ("Usage Data"). This Usage Data may include information such
                            as your computer's Internet Protocol address (e.g. IP address),
                            browser type, browser version, the pages of our Service that you
                            visit, the time and date of your visit, the time spent on those
                            pages, unique device identifiers and other diagnostic data.
                            </p>
                        <br />
                        <h5 style={{ "fontWeight": 'bold' }}>Tracking & Cookies Data</h5>
                        <p>
                            We use cookies and similar tracking technologies to track the
                            activity on our Service and hold certain information.

                            Cookies are files with small amount of data which may include an
                            anonymous unique identifier. Cookies are sent to your browser from
                            a website and stored on your device. Tracking technologies also used
                            are beacons, tags, and scripts to collect and track information and
                            to improve and analyze our Service.

                            You can instruct your browser to refuse all cookies or to indicate
                            when a cookie is being sent. However, if you do not accept cookies,
                            you may not be able to use some portions of our Service.
                        </p>

                        <p>Examples of Cookies we use:</p>
                        <ul style={{ color: '#37414F' }}>
                            <li>
                                Session Cookies. We use Session Cookies to operate our Service.
                            </li>
                            <li>
                                Preference Cookies. We use Preference Cookies to remember your
                                preferences and various settings.
                            </li>
                            <li>
                                Security Cookies. We use Security Cookies for security purposes.
                            </li>

                        </ul>
                        <br /><br />
                        <h3 className="Number1" style={{ "textAlign": "center" }}>Transfer of Data</h3>
                        <p>
                            Your information, including Personal Data, may be transferred to — and
                            maintained on — computers located outside of your state, province, country
                            or other governmental jurisdiction where the data protection laws may
                            differ than those from your jurisdiction.
                        </p>
                        <p>
                            If you are located outside <strong>{`${props.country}`}</strong>
                            and choose to provide information to us, please note that we transfer
                            the data, including Personal Data, to {`${props.location}`} and process it there.
                        </p>
                        <p>
                            Your consent to this Privacy Policy followed by your submission of such
                            information represents your agreement to that transfer.
                        </p>
                        <p>
                            <strong>{`${props.websitename}`}</strong> will take all steps reasonably
                            necessary to ensure that your data is treated securely and in accordance
                            with this Privacy Policy and no transfer of your Personal Data will take place
                            to an organization or a country unless there are adequate controls in place
                            including the security of your data and other personal information.
                        </p>
                        <br />
                    </CardBody>
                </Card>
            </Col >
        </div>
    )
}

class IncidentTemplate extends Component {
    state = {
        companyName: 'MiHungry Inc.',
        ...privacyPolicy
    }

    render () {
        return (
            <div>
                <Col md={12}>
                    <Card>
                        <CardBody>

                            <Header date='09-01-2018' logo='' />
                            <Prelude {...this.state} />
                            <Body {...this.state} />
                        </CardBody>
                    </Card>
                </Col>
            </div>
        )
    }
}



export default withRouter(IncidentTemplate);



// WEBPACK FOOTER //
// ./src/components/policies/templates/Privacy.js